"use strict";

class TOITTSelect {
    constructor(selectBox = "TOITTSelectBox", initALL = true) {
        this.selectBox = selectBox;
        console.log(`Init To ITT select interactive box module`);
        if (initALL) this.initDialog();
    }

    initDialog() {
        // init interactive act
        $('#' + this.selectBox)
            .on('shown.bs.modal', (event) => this.loadControlsValues(event))
            .on('hidden.bs.modal', () => this.finalizeBox())
            .on('keypress', (event) => {
                if (event.keyCode === 10 || event.keyCode === 13) {
                    this.onConfirm(event);
                    event.preventDefault();
                }
            })
            .find("button.confirm")
                .on('click', (event) => this.onConfirm(event));

        return this;
    }

    loadControlsValues() {
        $("#" + this.selectBox + " input[name=to_itt_box_scheme]").filter("[value=" + $("#to_itt-scheme").text() + "]").parent().button("toggle");
    }

    onConfirm() {
        $("#to_itt-scheme").text($("#" + this.selectBox).modal("hide").find(".box-to-itt-control.active > input:radio").val());
    }

    finalizeBox() {}
}

export default TOITTSelect;
